const PrivacyPolicy = (props) => {
  return (
    <>
      <div>
        <p>PRIVACY POLICY</p>

        <p>Last Revised: January 6th, 2026</p>

        <p class="has-small-font-size">
          This Privacy Policy explains how information about you is collected,
          used and disclosed by Snorkle, Inc. (“Snorkle”). This Privacy Policy
          applies to information we collect when you use our web or mobile
          applications (“Snorkle App”) or otherwise interact with us. This
          Privacy Policy applies to information collected in connection with
          Snorkle’s non-clinical, research and educational platform. The Snorkle
          App is not intended for clinical or patient-facing use.
        </p>

        <p class="has-small-font-size">
          We may change this Privacy Policy from time-to-time. If we make
          changes, we will notify you by revising the date at the top of the
          policy and, in some cases, we may provide you with additional notice
          (such as sending you an email notification). We encourage you to
          review the Privacy Policy whenever you access the Snorkle App to stay
          informed about our information practices and the ways you can help
          protect your privacy.
        </p>

        <p class="has-small-font-size">
          If you have questions, comments, or concerns regarding our Privacy
          Policy or practices, please contact us at support@snorkle.io.
        </p>

        <p>COLLECTION OF INFORMATION</p>

        <p class="has-small-font-size">Information You Provide to Us</p>

        <p class="has-small-font-size">
          We collect information you provide directly to us. For example, we
          collect information when you create an account, fill out a form, or
          otherwise communicate with us. The types of information we may collect
          include your name, email address, general location (such as city,
          state, or country), and other contact or identifying information you
          choose to provide.
        </p>

        <p class="has-small-font-size">
          Information We Collect Automatically When You Use the Snorkle App:
        </p>

        <ul>
          <li>
            When you access or use the Snorkle App, we automatically collect
            certain information about you.
          </li>
          <li>
            Device and Usage Information: We collect information about the
            device and browser you use to access the Snorkle App, including
            operating system, browser type, access times, pages viewed, IP
            address, and referring URLs.
          </li>
        </ul>

        <p class="has-small-font-size">
          Information Collected by Cookies and Other Tracking Technologies:
        </p>

        <p class="has-small-font-size">
          We use cookies and similar technologies to operate and improve the
          Snorkle App and understand how users interact with it. These
          technologies help us remember preferences, analyze usage patterns,
          and improve performance. We do not use cookies or tracking
          technologies for third-party behavioral advertising.
        </p>

        <p class="has-small-font-size">Information We Collect From Other Sources</p>

        <p class="has-small-font-size">
          We may obtain information from publicly available sources or
          third-party services used for account integrity, fraud prevention, or
          security purposes, and combine that information with information we
          collect through the Snorkle App.
        </p>

        <p class="has-small-font-size">NO PROTECTED HEALTH INFORMATION</p>

        <p class="has-small-font-size">
          Snorkle does not intend to collect or process protected health
          information or patient-identifiable medical data. Users should not
          submit such information through the Snorkle App.
        </p>

        <p class="has-small-font-size">USE OF INFORMATION</p>

        <p class="has-small-font-size">
          We may use information about you for various purposes, including to:
        </p>

        <ul>
          <li>
            Send technical notices, updates, security alerts and administrative
            messages;
          </li>
          <li>Provide, maintain and improve the Snorkle App;</li>
          <li>
            Respond to your comments, questions and requests and provide
            customer service;
          </li>
          <li>
            Monitor and analyze usage trends and system performance;
          </li>
          <li>
            Conduct internal research and analytics to improve functionality
            and user experience;
          </li>
          <li>
            Carry out any other purpose disclosed at the time the information
            was collected.
          </li>
        </ul>

        <p class="has-small-font-size">
          Snorkle is based in the United States, and the information we collect
          is governed by U.S. law. By accessing or using the Snorkle App or
          otherwise providing information to us, you consent to the processing
          and transfer of information in and to the United States and other
          countries where our service providers operate.
        </p>

        <p class="has-small-font-size">SHARING INFORMATION</p>

        <p class="has-small-font-size">
          We may share information about you as follows:
        </p>

        <ul>
          <li>
            With vendors and service providers who process information on our
            behalf to operate and improve the Snorkle App;
          </li>
          <li>
            To comply with applicable laws, regulations, or legal processes;
          </li>
          <li>
            To protect the rights, property, and safety of Snorkle and others;
          </li>
          <li>
            In connection with a merger, sale, financing, or acquisition of all
            or part of our business;
          </li>
          <li>
            With your consent or at your direction.
          </li>
          <li>
            We may also share aggregated or anonymized information that does not
            directly identify you.
          </li>
        </ul>

        <p class="has-small-font-size">ANALYTICS SERVICES</p>

        <p class="has-small-font-size">
          We may use third-party analytics providers to help us understand how
          users engage with the Snorkle App. These providers may collect
          information such as IP address, browser type, pages viewed, and time
          spent on the App. Analytics data is used solely for internal research,
          performance monitoring, and service improvement.
        </p>

        <p class="has-small-font-size">SECURITY</p>

        <p class="has-small-font-size">
          Snorkle takes reasonable administrative, technical, and physical
          measures to protect information against loss, theft, misuse, and
          unauthorized access or disclosure.
        </p>

        <p class="has-small-font-size">YOUR CHOICES</p>

        <p class="has-small-font-size">Account Information</p>

        <p class="has-small-font-size">
          You may update, correct, or delete information about you at any time
          by emailing support@snorkle.io. We may retain certain information as
          required by law or for legitimate business purposes.
        </p>

        <p class="has-small-font-size">Cookies</p>

        <p class="has-small-font-size">
          Most web browsers accept cookies by default. You can configure your
          browser to remove or reject cookies, though some features of the
          Snorkle App may not function properly.
        </p>

        <p class="has-small-font-size">Your California Privacy Rights</p>

        <p class="has-small-font-size">
          California residents may have the right to request access to,
          correction of, or deletion of personal information, and to opt out of
          certain uses of personal information, subject to applicable law. To
          exercise these rights, please contact us at support@snorkle.io.
        </p>

        <p class="has-small-font-size">CONTACT US</p>

        <p class="has-small-font-size">
          If you have any questions about this Privacy Policy, please contact us
          at support@snorkle.io.
        </p>
      </div>
    </>
  );
};

export default PrivacyPolicy;
